<mat-toolbar class="no-background">
  <span>お問い合わせ</span>
  <span class="spacer"></span>
  <mat-checkbox [(ngModel)]="showCompleted" (change)="onToggleCompleted()" style="margin-right: 32px;">
    完了も表示する
  </mat-checkbox>
  <a mat-button class="add-link" routerLink="/inquiry/create">
    <mat-icon>add</mat-icon>新しい問合せを作成
  </a>
  <a mat-button class="add-link" routerLink="/">
    <mat-icon>arrow_back</mat-icon>戻る
  </a>
</mat-toolbar>

<div style="margin-bottom: 12px;">
・各行をクリックすると、お問い合わせ詳細画面に進みます。内容の確認・追記などにご利用ください。<br>
・お問い合わせが解決した場合や、取り消したい場合も、詳細画面に進み「完了」をクリックしてください。
</div>

<div class="list-container">
  <ag-grid-angular
    class="ag-theme-alpine"
    style="width: 100%; height: calc(100vh - 350px);"
    [localeText]="localeText"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [pagination]="true"
    [paginationPageSize]="20"
    [paginationPageSizeSelector]="paginationPageSizeSelector"
    (rowClicked)="onRowClicked($event)">
  </ag-grid-angular>
</div>
